import axios from 'axios'
import qs from 'query-string'
import { QS_CONFIG } from '../../../features/common/Utilities'
import { parsedSearch } from 'BFF/utils/utils'
import { SAVINGS_PLAN_ENDPOINT } from 'cfgCommon/endpoints'

// This BFF gets counters for Vista - Vendedor para Planes de Ahorro

export async function getCounters(search, cancelToken) {
  const newSearch = qs.stringify(parsedSearch(search), QS_CONFIG)
  return await axios.get(`${SAVINGS_PLAN_ENDPOINT}/counters?${newSearch}`, { cancelToken })
}
